import { Modal } from "react-bootstrap";
import { useState } from "react";
import { toast } from "react-toastify";
import { useStoreStatus } from "../hooks/useStoreStatus";

export default function SettingsModal({ show, handleClose }) {
  const { isOpen, toggling, setOpen } = useStoreStatus();
  // ⚠️ Notification toggle нь одоогоор зөвхөн локал (backend холбоогүй) — аудитаар
  //    тэмдэглэсэн. Зан төлөв хэвээр үлдээв; дараа web push-тэй хамт шийднэ.
  const [notificationOn, setNotificationOn] = useState(true);

  const handleOpenOrganizationToggle = async (e) => {
    const res = await setOpen(e.target.checked);
    if (res.ok) toast.success("Амжилттай");
    else toast.error(res.error);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="bg-primary">
        <h4 className="header-title text-white">Тохиргоо</h4>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-centered mb-0">
          <tbody>
            <tr>
              <td style={{ borderBottom: "none" }}>
                Байгууллага {isOpen ? "хаах" : "нээх"}
              </td>
              <td style={{ borderBottom: "none" }}>
                <div className="d-flex justify-content-end">
                  {toggling ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    <>
                      <input
                        type="checkbox"
                        id="switch01"
                        checked={isOpen}
                        onChange={handleOpenOrganizationToggle}
                        data-switch="success"
                      />
                      <label
                        htmlFor="switch01"
                        data-on-label="Yes"
                        data-off-label="No"
                        className="mb-0 d-block"
                      />
                    </>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ borderBottom: "none" }}>
                Notification {notificationOn ? "унтраах" : "асаах"}
              </td>
              <td style={{ borderBottom: "none" }}>
                <div className="d-flex justify-content-end">
                  <input
                    type="checkbox"
                    id="switch02"
                    checked={notificationOn}
                    onChange={(e) => setNotificationOn(e.target.checked)}
                    data-switch="success"
                  />
                  <label
                    htmlFor="switch02"
                    data-on-label="Yes"
                    data-off-label="No"
                    className="mb-0 d-block"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <div className="btn btn-outline-primary" onClick={handleClose}>
          Хаах
        </div>
      </Modal.Footer>
    </Modal>
  );
}
